import React from "react";
import ReportList from "../components/reports/ReportList";

function ReportsHeaderIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="text-[#333333]"
    >
      <mask id="mask0_1400_46646" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1400_46646)">
        <path
          d="M5.6155 20C5.17117 20 4.79083 19.8418 4.4745 19.5255C4.15817 19.2092 4 18.8288 4 18.3845V5.6155C4 5.17117 4.15817 4.79083 4.4745 4.4745C4.79083 4.15817 5.17117 4 5.6155 4H10.3155C10.2243 3.48967 10.3464 3.02875 10.6817 2.61725C11.0169 2.20575 11.4595 2 12.0095 2C12.5595 2 13.0022 2.20575 13.3375 2.61725C13.6728 3.02875 13.7885 3.48967 13.6845 4H18.3845C18.8288 4 19.2092 4.15817 19.5255 4.4745C19.8418 4.79083 20 5.17117 20 5.6155V18.3845C20 18.8288 19.8418 19.2092 19.5255 19.5255C19.2092 19.8418 18.8288 20 18.3845 20H5.6155ZM5.6155 19H18.3845C18.5385 19 18.6796 18.9359 18.8077 18.8078C18.9359 18.6796 19 18.5385 19 18.3845V5.6155C19 5.4615 18.9359 5.32042 18.8077 5.19225C18.6796 5.06408 18.5385 5 18.3845 5H5.6155C5.4615 5 5.32042 5.06408 5.19225 5.19225C5.06408 5.32042 5 5.4615 5 5.6155V18.3845C5 18.5385 5.06408 18.6796 5.19225 18.8078C5.32042 18.9359 5.4615 19 5.6155 19ZM8 16.2693H13C13.1417 16.2693 13.2604 16.2213 13.3562 16.1253C13.4521 16.0293 13.5 15.9103 13.5 15.7685C13.5 15.6267 13.4521 15.508 13.3562 15.4125C13.2604 15.317 13.1417 15.2693 13 15.2693H8C7.85833 15.2693 7.73958 15.3173 7.64375 15.4133C7.54792 15.5091 7.5 15.628 7.5 15.77C7.5 15.9118 7.54792 16.0305 7.64375 16.126C7.73958 16.2215 7.85833 16.2693 8 16.2693ZM8 12.5H16C16.1417 12.5 16.2604 12.452 16.3562 12.356C16.4521 12.26 16.5 12.1411 16.5 11.9993C16.5 11.8574 16.4521 11.7388 16.3562 11.6433C16.2604 11.5478 16.1417 11.5 16 11.5H8C7.85833 11.5 7.73958 11.548 7.64375 11.644C7.54792 11.74 7.5 11.8589 7.5 12.0008C7.5 12.1426 7.54792 12.2612 7.64375 12.3567C7.73958 12.4522 7.85833 12.5 8 12.5ZM8 8.73075H16C16.1417 8.73075 16.2604 8.68275 16.3562 8.58675C16.4521 8.49092 16.5 8.372 16.5 8.23C16.5 8.08817 16.4521 7.9695 16.3562 7.874C16.2604 7.7785 16.1417 7.73075 16 7.73075H8C7.85833 7.73075 7.73958 7.77875 7.64375 7.87475C7.54792 7.97075 7.5 8.08967 7.5 8.2315C7.5 8.37333 7.54792 8.492 7.64375 8.5875C7.73958 8.683 7.85833 8.73075 8 8.73075ZM12 4.44225C12.2167 4.44225 12.3958 4.37142 12.5375 4.22975C12.6792 4.08808 12.75 3.90892 12.75 3.69225C12.75 3.47558 12.6792 3.29642 12.5375 3.15475C12.3958 3.01308 12.2167 2.94225 12 2.94225C11.7833 2.94225 11.6042 3.01308 11.4625 3.15475C11.3208 3.29642 11.25 3.47558 11.25 3.69225C11.25 3.90892 11.3208 4.08808 11.4625 4.22975C11.6042 4.37142 11.7833 4.44225 12 4.44225Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default function ReportsPage() {
  return (
    <div className="min-h-screen bg-[#F4F7FB] font-['Open_Sans']">
      {/* Header card (same spacing as Routes) */}
      <div className="pt-[32px] px-[32px]">
        <div className="w-full h-[89px] bg-[#FDFEFF] rounded-[8px] px-[24px] py-[16px] flex items-center justify-between">
          <div className="flex flex-col justify-between h-full">
            <div className="flex items-center gap-2 h-[31px]">
              <h1 className="text-[20px] font-extrabold leading-[155%] text-[#333333]">
                Reports
              </h1>
              <ReportsHeaderIcon />
            </div>
            <p className="text-[14px] font-light leading-[155%] text-[#333333]">
              Review and confirm detection reports
            </p>
          </div>
        </div>
      </div>

      {/* List area */}
      <div className="pt-[16px] px-[32px]">
        <ReportList />
      </div>
    </div>
  );
}
